import axios from "axios";
export default class BaseApi {
    static setConfig(config) {
        this.config = config;
    }
    static getConfig() {
        return this.config;
    }
    init(config) {
        var _a, _b;
        this.request = axios.create({
            baseURL: config === null || config === void 0 ? void 0 : config.baseURL
        });
        const requestInterceptors = this.defaultRequestInterceptors();
        const responseInterceptors = this.defaultResponseInterceptors();
        for (const requestInterceptor of requestInterceptors)
            (_a = this.request) === null || _a === void 0 ? void 0 : _a.interceptors.request.use(requestInterceptor);
        for (const responseInterceptor of responseInterceptors) {
            const interceptor = responseInterceptor();
            (_b = this.request) === null || _b === void 0 ? void 0 : _b.interceptors.response.use(interceptor.success, interceptor.error);
        }
    }
    constructor() { }
    static getInstance() {
        if (!this.obj) {
            this.obj = new this();
        }
        this.obj.init(this.config);
        return this.obj;
    }
}
BaseApi.config = {};
